
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({
  button: (p) => {
    const {
      hasCustomCSS,
      // widgetTheme: wt,
      commonUIStyles = {
        button: () => ({}),
      },
      cssCustomClasses,
    } = p;
    
    function hasButtonCustomClass() {
      if (cssCustomClasses['Button__button___2a549'] || cssCustomClasses['ecal-primary-button']) {
        return true;
      }

      return false;
    }

    function getButtonStyles () {
      // If there is custom css and the button has a custom class, return an empty object.
      if (hasCustomCSS && hasButtonCustomClass()) {
        return {};
      }

      // Otherwise, return the common styles.
      return commonUIStyles.button();
    }

    return  {
      '&.MuiButton-root': {
        // ensure that ecal-custom buttons will be used
        ...getButtonStyles(),
        // MUI Button default font bug: hard code the font family for now since the css font family is not being applied.
        // In custom css, the font family for primary button is set to 'Font-Regular', 'Regular' for most cases.
        fontFamily: `'PrimaryButton-Font', 'Font-Regular', 'Regular', 'GothamRounded-Book' !important;`,
      },
    };
  },

});

export default styles;
export const useStyles = makeStyles(styles);
